<template>
  <div class="flex w-full items-center">
    <fieldset class="min-w-full max-w-full flex flex-col h-full">
      <span style="color: var(--va-primary)" class="va-input-label">
        {{ props.label }}
      </span>

      <span class="w-full pt-2">
        <VaSwitch v-model="inputValue" :size="props.size" :messages="props.helpText" :disabled="props.disabled" />
      </span>
    </fieldset>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue"

const props = defineProps({
  label: { type: String, default: "" },
  modelValue: { type: Boolean, default: false },
  size: {
    type: String as () => "small" | "medium" | "large",
    default: "small",
  },
  helpText: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
})

const emit = defineEmits(["update:modelValue"])
const inputValue = ref(props.modelValue)

watch(
  () => props.modelValue,
  (val) => {
    inputValue.value = val
  },
)

watch(inputValue, (val) => {
  emit("update:modelValue", val)
})
</script>
